import React from 'react';

const badgeStyle = { fontSize: '0.8rem', padding: '6px 10px' };

export default function WarningBadge({ icon, text }) {
  return (
    <span className='badge bg-warning text-dark border border-warning' style={badgeStyle}>
      <i className={`${icon || 'fa-solid fa-triangle-exclamation'} me-1`}></i>
      {text}
    </span>
  );
}
